import { IEvent } from '@interfaces/event';
import { IUser } from '@interfaces/user';
import { IEventParticipant } from '@interfaces/eventParticipant';
import { IXRHrPersonaTypes } from '../interfaces';
import { EventRole } from '@interfaces/event';

export const isBroadcastEnabled = (
  currentEventParticipant: IEventParticipant | null,
) =>
  currentEventParticipant?.role === EventRole.Admin ||
  currentEventParticipant?.role === EventRole.Coordinator;

export const isPrivateChatEnabled = ({
  user,
  currentEvent,
}: {
  user: IUser;
  currentEvent?: IEvent;
}) => {
  const isOfficeHours =
    currentEvent?.eventTags &&
    currentEvent?.eventTags.indexOf('OfficeHours') > -1;
  const isHRFacilitator =
    user?.hrData?.persona?.toUpperCase() === IXRHrPersonaTypes.HR_Facilitator;

  return !isOfficeHours || (isOfficeHours && isHRFacilitator);
};
